export default "__VITE_ASSET__DxjTxlLD__"